export function initEditor() {
  const cache = new Map(); // To store the current state of variables

  function updateDynamicTags(variableKey, variableValue) {
    const elements = document.querySelectorAll(
      `[data-mvthru-preview=${variableKey}]`,
    );

    elements.forEach((element) => {
      const previewKey = element.getAttribute("data-mvthru-preview-key");

      if (previewKey) {
        if (element.getAttribute(previewKey) !== variableValue) {
          element.setAttribute(previewKey, variableValue);
          console.log(
            `Updated ${previewKey} of element:`,
            element,
            `to: ${variableValue}`,
          );
        }
      } else {
        element.textContent = variableValue;
      }
    });
  }

  function handleVariableUpdate(data) {
    const { key, value } = data.variable;

    // Update CSS vars only on message events
    if (!cache.has(key) || cache.get(key) !== value) {
      document.documentElement.style.setProperty(`--mvthru-${key}`, value);
      cache.set(key, value);
    }

    // Update dynamic tags
    console.log("check", key, value);
    updateDynamicTags(key, value);
  }

  function handleNavigation() {
    cache.forEach((value, key) => {
      // Temp solution to persist preview changes
      setTimeout(() => {
        updateDynamicTags(key, value);
      }, "200");
    });
  }

  // Listen for messages to update state and CSS vars
  window.addEventListener("message", (event) => {
    console.log("Message received.", event.data);
    if (event.data && event.data.variable) {
      handleVariableUpdate(event.data);
    }
  });

  document.addEventListener("mvthru-router", handleNavigation);
}
